import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { CustomizerSettingsService } from "../customizer-settings/customizer-settings.service";
import { ToastrService } from "ngx-toastr";
import { OperacionActualizadaProjection } from "src/app/models/operacionactualizadaprojection";
import { OperacionService } from "src/app/services/operacion.service";
import { SuscripcionesService } from "src/app/services/suscripciones.service";
import { CookieService } from "ngx-cookie-service";
import { Suscripcion } from "src/app/models/suscripcion";
import { TableColmuns } from "src/app/interface/TableColumnsinterface";
import { TipoOperacion } from "src/app/constants/tipo-operacion";
import { ModeloEjecucionService } from "src/app/services/modelo-ejecucion.service";
import { ModeloService } from "src/app/services/modelo.service";
@Component({
  selector: "app-seguimiento-carteras",
  templateUrl: "./seguimiento-carteras.component.html",
  styleUrl: "./seguimiento-carteras.component.scss",
})
export class SeguimientoCarterasComponent implements OnInit {
    fechaSeleccionada: string = 'fechaInicio';  // Default selection
    modeloSeleccionadoTipo: string = 'modelo';  // Default selection
    
  listaOperaciones: OperacionActualizadaProjection[];
  listaModelos: any[] = [];
  listaCarteras: any[] = [];
  modeloSeleccionado: any;
  idModeloSeleccionado: any;
  userId = 0;
  fechaInicio = new Date().toISOString().split('T')[0];
  fechaPeriodo = "";
  COMPRA = "COMPRA";
  VENTA = "VENTA";
  ALCISTA = "Alcista";
  BAJISTA = "Bajista";
  pagina = 0;
  offset = 0;
  limite = 100;
  totalRegistros = 0;
  tableColumns: TableColmuns[] = [
    {
      id: "nombreCartera",
      name: "Cartera",
      isShow: true,
      isDate: false,
      isNumber: false,
      isString: true,
    },    
    {
      id: "nombreModelo",
      name: "Subcartera",
      isShow: true,
      isDate: false,
      isNumber: false,
      isString: true,
    },
    {
      id: "nombrecompania",
      name: "Compañía",
      isShow: true,
      isDate: false,
      isNumber: false,
      isString: true,
    },{
      id: "vermodelo",
      name: "Ver Modelo",
      isShow: true,
      isDate: false,
      isNumber: false,
      isString: true,
    },
    {
      id: "fechaoperacion",
      name: "Fecha",
      isShow: true,
      isDate: true,
      isNumber: false,
      isString: false,
    },
    {
      id: "bajistaTxt",
      name: "Alcista o Bajista",
      isShow: true,
      isDate: false,
      isNumber: false,
      isString: true,
    },
    {
      id: "entrada",
      name: "Entrada",
      isShow: true,
      isDate: false,
      isNumber: false,
      isString: true,
    },
    {
      id: "precioentradareal",
      name: "Precio Entrada",
      isShow: true,
      isDate: false,
      isNumber: true,
      isString: false,
    },
    {
      id: "stoplossinicial",
      name: "Stop loss",
      isShow: false,
      isDate: false,
      isNumber: true,
      isString: false,
    },
    {
      id: "actualizacion",
      name: "Actualización stoploss",
      isShow: false,
      isDate: false,
      isNumber: false,
      isString: true,
    },
    {
      id: "salida",
      name: "Salida",
      isShow: false,
      isDate: false,
      isNumber: true,
      isString: false,
    },
    {
      id: "preciosalidareal",
      name: "Precio Salida",
      isShow: false,
      isDate: false,
      isNumber: true,
      isString: false,
    },
  ];

  operacionesColumns: string[] = [
    "nombreCartera",
    "nombreModelo",
    "nombrecompania",
    "vermodelo",
    "fechaoperacion",
    "bajistaTxt",
    "entrada",
    "precioentradareal",
    "stoplossinicial",
    "actualizacion",
    "salida",
    "preciosalidareal",
  ];

  sortColumnId: string | null = null;
  sortDirection: "asc" | "desc" = "asc";

  constructor(
    public themeService: CustomizerSettingsService,
    private toastr: ToastrService,
    private operacionService: OperacionService,
    private suscripcionService: SuscripcionesService,
    private modeloService: ModeloService,
    private cookieService: CookieService,
    private cd: ChangeDetectorRef,
    private modeloEjecucionService: ModeloEjecucionService
  ) {
    this.listaOperaciones = [];
  }
  ngOnInit(): void {
    this.userId = Number(
      this.cookieService.get("userId") ? this.cookieService.get("userId") : 0
    );
    this.consultarModelos();
    this.consultarCarteras();
    this.consultarSuscripciones();
  }

  consultarSuscripciones() {
    if (this.userId) {
      this.suscripcionService.buscarTop10ByidUsuario(this.userId).subscribe({
        next: (value: Suscripcion[]) => {
          if (value && value.length) {
            for (let i = 0; i < value.length; i++) {
              if (value[i].fechaActualizacion) {
                this.fechaInicio = value[i].fechaActualizacion;
                this.fechaPeriodo = value[i].fechaActualizacion;
                break;
              }
            }
            if (this.fechaInicio) {
              this.consultarOperaciones();
            } else {
              this.toastr.error("No se han actualizado tus carteras");
            }
          }
          this.cd.markForCheck();
        },
        error: (err) => {
          this.toastr.error("Ocurrió un error consultando suscripciones");
        },
      });
    }
  }

  consultarModelos() {
    this.modeloService.consultarModelosSuscritosUsuario(this.userId).subscribe({
      next: (value) => {
        this.listaModelos = value;
        this.cd.markForCheck();
        this.recargarmodelos();
      },
      error: (err) => {
        this.toastr.error("Ocurrió un error consultando modelos");
      },
    });
  }
  recargarmodelos() {
    //iterar en listamodelos
    console.log(this.listaModelos);
    for (let modelo of this.listaModelos) {
      let idtemp = modelo.idmodelo;
      console.log('modelo' + idtemp);
      this.modeloEjecucionService.ejecutarModeloPorId(idtemp).subscribe({
        next: (event) => {
          console.log('Evento SSE recibido en SeguimientoCarteras:', event);
          // Aquí puedes añadir lógica para actualizar la UI si es necesario
        },
        error: (err) => {
          console.error('Error en la ejecución del modelo:', err);
          this.toastr.error(`Error al ejecutar el modelo ${idtemp}`);
        },
        complete: () => {
          console.log(`Ejecución completada para el modelo ${idtemp}`);
        }
      });
    }
  }

  consultarCarteras() {
    this.modeloService.consultarCarterasSuscritosUsuario(this.userId).subscribe({
      next: (value) => {
        this.listaCarteras = value;
        this.cd.markForCheck();
      },
      error: (err) => {
        this.toastr.error("Ocurrió un error consultando modelos");
      },
    });
  }

  cambiarFecha(event: any) {  
    this.consultarOperaciones();
  }

  consultarOperaciones() {
    if (!this.fechaPeriodo && this.fechaSeleccionada === 'fechaPeriodo') {
      this.toastr.error("Por favor seleccione una fecha de actualización");
      return;
    }
    if (!this.fechaInicio && this.fechaSeleccionada === 'fechaInicio') {
      this.toastr.error("Por favor seleccione una fecha de actualización");
      return;
    }

    if (this.pagina > 1) {
      this.offset += this.limite;
    } else {
      this.offset = 0;
    }
    this.operacionService.listarOperacionesActualizadas(
        this.userId,
        this.formatFecha(new Date(this.fechaInicio)),
        this.offset,
        this.limite,
        this.formatFecha(new Date(this.fechaPeriodo)),
        this.modeloSeleccionado ? this.modeloSeleccionado : 0,this.idModeloSeleccionado?this.idModeloSeleccionado:0, this.fechaSeleccionada, this.modeloSeleccionadoTipo
      )
      .subscribe({
        next: (value: any) => {
            this.listaOperaciones = value.listaOperaciones;
            this.totalRegistros = value.total;
            this.calcularCompraVenta();
          
          this.cd.markForCheck();
          this.toastr.success("Datos consultados exitosamente");
        },
        error: (err) => {
          this.toastr.error("Ocurrió un error consultando operaciones");
        }, complete:()=> {
          this.cd.markForCheck();

        },
      });
  }

  calcularCompraVenta() {
    if(this.listaOperaciones && this.listaOperaciones.length) {

      this.listaOperaciones.forEach((ope) => {
        if (ope.bajista) {
          ope.bajistaTxt = this.BAJISTA;
          if (ope.tipooperacion === TipoOperacion.ENTRADA) {
            ope.entrada = this.VENTA;
            ope.salida = "";
          } else if (ope.tipooperacion === TipoOperacion.SALIDA) {
            ope.salida = this.COMPRA;
            ope.entrada = "";
          } else if (ope.tipooperacion === TipoOperacion.ACTUALIZACION) {
            ope.salida = "";
            ope.entrada = "";
            ope.actualizacion = TipoOperacion.ACTUALIZACION;
          }
        } else {
          ope.bajistaTxt = this.ALCISTA;
          if (ope.tipooperacion === TipoOperacion.ENTRADA) {
            ope.entrada = this.COMPRA;
            ope.salida = "";
          } else if (ope.tipooperacion === TipoOperacion.SALIDA) {
            ope.salida = this.VENTA;
            ope.entrada = "";
          } else if (ope.tipooperacion === TipoOperacion.ACTUALIZACION) {
            ope.salida = "";
            ope.entrada = "";
            ope.actualizacion = TipoOperacion.ACTUALIZACION;
          }
        }
      });
    }
  }

  sortBy(column: TableColmuns) {
    if (!this.listaOperaciones || this.listaOperaciones.length === 0) {
      return;
    }
    const columnId = column.id;
    if (this.sortColumnId === columnId) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      this.sortColumnId = columnId;
      this.sortDirection = "asc";
    }
    const direction = this.sortDirection === "asc" ? 1 : -1;
    const isNumber = column.isNumber;
    const isDate = column.isDate;
    this.listaOperaciones = [...this.listaOperaciones].sort((a: any, b: any) => {
      const aRaw = a[columnId];
      const bRaw = b[columnId];
      if (aRaw == null && bRaw == null) return 0;
      if (aRaw == null) return 1;
      if (bRaw == null) return -1;
      let aVal: any = aRaw;
      let bVal: any = bRaw;
      if (isDate) {
        aVal = new Date(aRaw).getTime();
        bVal = new Date(bRaw).getTime();
      } else if (isNumber) {
        aVal = Number(aRaw);
        bVal = Number(bRaw);
      } else {
        aVal = String(aRaw).toLowerCase();
        bVal = String(bRaw).toLowerCase();
      }
      if (aVal < bVal) return -1 * direction;
      if (aVal > bVal) return 1 * direction;
      return 0;
    });
  }

  cambioDePagina(event: any) {
    this.pagina = event.pageIndex;
    this.consultarOperaciones();
  }

  formatFecha(fecha: Date) {
    if(!fecha || fecha.toString() == 'Invalid Date') {
      return "";
    }
      let fechaDate = fecha;
      let month = fechaDate.getMonth() + 1;
      return month + "/" + fechaDate.getDate() + "/" + fechaDate.getFullYear();       
  }

  checkoNombreCompania(tablecolope: any) {
    return tablecolope.id !== "nombrecompania";
  }

  checkColumnaNumerica(tablecolope: any) {
    let valor =  (tablecolope.id === 
    'precioentradareal' || tablecolope.id === 
    'stoplossinicial' || tablecolope.id === 
    'preciosalidareal')  ;
   
    return valor;
  }

  formatearValores(value: any) {

    return value;
  }

  buscarPorIdModelo(){

  }
  onFechaSeleccionadaChange() {
    // Any additional logic when the date selection changes
   
  }

  onModeloSeleccionadoChange() {
    // Additional logic when the model selection changes
    if (this.modeloSeleccionadoTipo === 'modelo') {
      this.idModeloSeleccionado = null;  // Clear the other model selection
    } else {
      this.modeloSeleccionado = null;  // Clear the other model selection
    }
  }
}


